module.exports = __webpack_public_path__ + "img/image.b06cccd5.png";